// import AWSImg from '../Assets/Images/AWS_Academy_Cloud_Foundations.jpg'
import AWSlogo from '../Assets/icons/aws-logo.svg'
// import AWSMLimg from '../Assets/Images/AWS_Academy_Graduate___AWS_Academy_Machine_Learning_Foundations.jpg'
// import IOcert from '../Assets/Images/IOcert.jpg'
import IOlogo from '../Assets/icons/IOlogo.png'
import Udemylogo from '../Assets/icons/Udemy.svg'

// import UdemyImg from '../Assets/Images/Image Processing Udemy_pages-to-jpg-0001.jpg'
// import UdemyImg1 from '../Assets/Images/udemyImg.jpeg'

const CertificatesInfo = [
    {
        id: 1,
        ava_icon:
            'https://cdn.theforage.com/vinternships/companyassets/SKZxezskWgmFjRvj9/BqF6gmrmLunCkdqKM/1710332417845/01-bcgx-logo-color-positive-RGB-small.png',
        link: 'https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/BCG%20/gabev3vXhuACr48eb_BCG_SKZpDgrDYkMhs5NtJ_1725110112812_completion_certificate.pdf',
        title: 'GenAI Job Simulation',
        subheader: 'BCGX',
        img: 'https://iili.io/KsciWmB.md.jpg',
    },
    {
        id: 3,
        ava_icon: AWSlogo,
        link: 'https://www.credly.com/go/veuWgVBf',
        title: 'AWS Academy Cloud Foundations',
        subheader: 'AWS Training and Certification',
        img: 'https://iili.io/KscHLil.md.jpg',
    },
    {
        id: 4,
        ava_icon: AWSlogo,
        link: 'https://www.credly.com/badges/fb21fe16-a1a5-4fdd-a22f-ffb300a773df/public_url',
        title: 'AWS Academy Machine Learning',
        subheader: 'AWS Training and Certification',
        img: 'https://iili.io/KscHZf2.md.jpg',
    },
    {
        id: 5,
        ava_icon: Udemylogo,
        link: 'https://ude.my/UC-485e29eb-edfe-4ff0-96a1-7392b3a72c27',
        title: 'Image Processing and Computer Vision with Python & OpenCV',
        subheader: 'Udemy',
        img: 'https://iili.io/KscHtlS.md.jpg',
    },
    {
        id: 6,
        ava_icon: Udemylogo,
        link: 'https://ude.my/UC-2fd7c466-3b66-440a-a8dc-75dad97bec55',
        title: 'Complete JAVASCRIPT with HTML5,CSS3 from zero to Expert',
        subheader: 'Udemy',
        img: 'https://iili.io/KscHpRe.md.jpg',
    },

    {
        id: 7,
        ava_icon: IOlogo,
        link: 'https://www.linkedin.com/in/pradeep-mokashi/details/certifications/',
        title: 'Certified Cyber Crime Intervention Officer',
        subheader: 'National Security Database',
        img: 'https://iili.io/KscHmJ9.md.jpg',
    },
    {
        id: 8,
        ava_icon: 'https://img.icons8.com/fluency/48/hugging-face_app.png',
        link: 'https://huggingface.co/spaces/agents-course/unit_1_quiz/discussions/237#67eb88d75efb3c1d5e1727be',
        title: 'Fundamentals of AI Agents',
        subheader: 'Hugging Face',
        img: 'https://iili.io/KsciVeV.md.jpg',
    },
]

export default CertificatesInfo
